import {
  WhatsNextOption,
  WhatsNextOptionId,
} from "./WhatsNext/WhatsNextOption";

import { useWidgetSettings } from "../../widget/useWidgetSettings";
import { createDummyLocationBased } from "./WhatsNext/dummyLocationBased";
import { ReactComponent as ChatWithDoctorIcon } from "../../assets/whatsNext/chatWithDoctor.svg";
import { ReactComponent as ViewSummaryIcon } from "../../assets/whatsNext/viewSummaryIcon.svg";
import { ReactComponent as SendToDoctorIcon } from "../../assets/whatsNext/sendToDoctorIcon.svg";
import { ReactComponent as SaveAssessment } from "../../assets/whatsNext/saveAssessment.svg";
import { ReactComponent as StartOverIcon } from "../../assets/whatsNext/startOverIcon.svg";
import { WhatsNextViewSummary } from "./WhatsNext/whatsNextViewSummary";
import { WhatsNextStartOver } from "./WhatsNext/whatsNextStartOver";
import { PdfSummary } from "./WhatsNext/pdfSummary";
import { WhatsNextShareCase } from "./WhatsNext/whatsNextShareCase";
import { useClinicData } from "../../clinic/clinicHooks";
import { FontEndFeatureFlags } from "@kahunmedical/common-configuration/dist/configuration/frontend";
import { ConfigSubObjectKeys } from "@kahunmedical/common-configuration/dist/generated";

const allPartners = () => true;

const createWhatsNext: (option: WhatsNextOption) => WhatsNextOption = ({
  name,
  displayText,
  component,
  allowForPartner,
  icon,
  backgroundColor,
  featureFlag,
}) => ({
  name,
  displayText: displayText || name,
  component,
  allowForPartner: allowForPartner || allPartners,
  icon,
  backgroundColor,
  featureFlag: featureFlag || null,
});

export const WhatsNextOptionsIndex: WhatsNextOption[] = [
  createWhatsNext({
    name: WhatsNextOptionId.DoctorChat,
    displayText: "CHAT_WITH_DOCTOR",
    component: createDummyLocationBased(WhatsNextOptionId.DoctorChat),
    icon: ChatWithDoctorIcon,
    backgroundColor: "#E4EFFF",
    featureFlag: "whatsNextDoctorChat",
  }),
  createWhatsNext({
    name: WhatsNextOptionId.ViewSummary,
    displayText: "VIEW_SUMMARY",
    component: WhatsNextViewSummary,
    icon: ViewSummaryIcon,
    backgroundColor: "#E1F4F1",
  }),
  createWhatsNext({
    name: WhatsNextOptionId.SendToDoctor,
    displayText: "SEND_TO_DOCTOR",
    component: WhatsNextShareCase,
    icon: SendToDoctorIcon,
    backgroundColor: "#FCEFE7",
  }),
  createWhatsNext({
    name: WhatsNextOptionId.SaveAssessment,
    displayText: "SAVE_ASSESSMENT",
    component: PdfSummary,
    icon: SaveAssessment,
    backgroundColor: "#FFF9DB",
    featureFlag: "savePdfAssessment",
  }),
  createWhatsNext({
    name: WhatsNextOptionId.StartOver,
    displayText: "START_NEW_CASE",
    component: WhatsNextStartOver,
    icon: StartOverIcon,
    backgroundColor: "#E6E4FF",
  }),
];

export function useWhatsNextOptions(): WhatsNextOption[] {
  const { partnerId } = useWidgetSettings();

  const { settings } = useClinicData();

  return WhatsNextOptionsIndex.filter(
    (option) =>
      option.allowForPartner(partnerId) &&
      (!option.featureFlag ||
        settings.makeConfigObjectForKey(
          // Read key from settings to see if this option is on/off
          FontEndFeatureFlags,
          ConfigSubObjectKeys.fe,
        )[option.featureFlag]),
  );
}
